<template>
  <Webview>
    <div class="_fill">
      <router-view v-if="ready" />

      <ResultPage v-if="error">
        <div>
          網路異常<br>
          請重新再試
        </div>
      </ResultPage>
    </div>

    <PageTab />
  </Webview>
</template>

<script> 
export default {
  mounted() {
    this.init();
  },
  data() {
    return {
      ready: false,
      error: false,
    }
  },
  methods: {
    async init() {
      try {
        await this.$store.dispatch("GetUserInfo");
        this.ready = true;
      } catch (error) {
        NOTIFICATION("e", error?.message || error?.status_message || this.$tp("warn.systemError"));
        this.error = true;
      }

      if (this.$route.name === "index") {
        this.$router.replace({ path: "/channel" });
      }
    },
  },
}
</script>

<style>
</style>
